import React from 'react';

const Education = () => {
  return (
    <section className="education">
      <h2>Education</h2>
      <div className="education-item">
        <h3 className="institution">The London School of Economics</h3>
        <h4 className="degree">MSc Development Management (Specialising in Applied Development Economics)</h4>
        <h5 className="award">Dissertation: The China Shock In Chilean Local Labour Markets (Distinction)</h5>
      </div>
      <div className="education-item">
        <h3 className="institution">Erasmus University Rotterdam</h3>
        <h4 className="degree">BSc International Economics and Business Economics</h4>
        <h5 className="award">First Year Cum Laude Award</h5>
        <h6 className="award">Dissertation: Impact Of Locational Characteristics On The Clustering Of ICT Startups: An Empirical Study In The Netherlands (78)</h6>
      </div>
    </section>
  );
};

export default Education;

